module.exports = __webpack_public_path__ + "img/ob2.49db8437.png";